hrd.manager.StatusMessageManager = hrd.AbstractHTMLFormPopup.extend({
	JSON_PROVIDER: 'com.hrd.struts.status.messages.StatusMessageJsonProvider',
	init: function(detailData, options) {
		var defaults = {
			impl: 'hrd.manager.StatusMessageManager'
		};
		this.detailData = detailData;
		this.toolbox = new hrd.Toolbox();

		this._super($.extend({}, defaults, options));
		this.settings.dialogOptions = {
			modal: true,
			hideHeader: true,
			destroyOnClose: true,
			okLabel: xlate('common.dialog.close.btn'),
			showCancelButton: false,
		};
	},
	createHTMLFactory: function() {
		var df = new hrd.HtmlDialogFactory({
			width: $('body').usingChromaFlow() ? 'auto' : '800',
			height: $('body').usingChromaFlow() ? undefined : '120',
		});
		df.useHTMLSnippet('<div class="message-container"></div>');
		return df;
	},
	show: function(options) {
		return dashboardInstance.invokeProvider(this.JSON_PROVIDER, 'getMessages', options)
			.then(data => {
				if (data.messages.length == 0) {
					return $.never();
				} else {
					return this.openFormDialog(data, this.settings.dialogOptions);
				}
			})
			.then(() => $.when());
	},
	openDialog: function(formInstance, dialogId, data) {
		$(dialogId).closest('.ui-dialog').addClass('status-message-dialog');

		var tmp = '<div class="message-item {type}-type">' + //
			'    <span class="message-item-icon">{icon}</span>' + //
			'    <span class="message-item-text"><span class="selectable">{message}</span></span>' + //
			'</div>';
		var $msgContainer = $('.message-container', formInstance.$container);

		data.messages.forEach(m => {
			var iconPart = this.toIcon(m);
			var html = this.toolbox.replaceParams(tmp, { type: m.type.toLowerCase(), icon: iconPart, message: m.message });
			$msgContainer.append(html);
		});

		var totalHeight = Math.min($msgContainer.outerHeight(true), 500); // max acceptable height will be 500
		$msgContainer.parent().css('height', totalHeight + 'px');
	},
	toIcon: function(message) {
		var options = {};
		switch (message.type) {
			case 'ERROR':
				options.icon = 'fas fa-times-circle';
				options.color = '#FE6E61';
				break;
			case 'WARNING':
				options.icon = 'fas fa-exclamation-triangle';
				options.color = '#F89200';
				break;
			case 'INFO':
			default:
				options.icon = 'fas fa-info-circle';
				options.color = '#5DC8F0';
				break;
		}
		var icon = this.toolbox.createIconTemplate(options);
		return icon;
	}
});